// extracted by mini-css-extract-plugin
export default {"table_search":"TableSearch_table_search__-cbQz"};